import React, { useState } from 'react';

function EscolaPicker({ show, escolas = [], selectedCnpj, onSelect, onClose }) {
  const [search, setSearch] = useState('');

  if (!show) return null;

  const normalize = s => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const termo = normalize(search);

  const filtered = escolas
    .filter(e =>
      normalize(e.nome).includes(termo) ||
      e.cnpj.includes(search) ||
      normalize(e.municipio).includes(termo)
    )
    .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));

  function handleSelect(e) {
    onSelect(e);
    setSearch('');
  }

  function handleClose() {
    setSearch('');
    onClose();
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 1065,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        className="modal-content"
        style={{
          width: '90%',
          maxWidth: 620,
          height: 500,
          minHeight: 500,
          maxHeight: 500,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 6,
          overflow: 'hidden',
          backgroundColor: '#fff',
        }}
      >
        {/* Header */}
        <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
          <h6 className="modal-title mb-0 small">
            <i className="bi bi-building me-2"></i>SELECIONAR CLIENTE / ENTIDADE
          </h6>
          <button type="button" className="btn-close btn-close-white" onClick={handleClose} />
        </div>

        {/* Body */}
        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '1rem' }}>
          {/* Campo de busca */}
          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">
              <i className="bi bi-search me-1"></i>BUSCAR
            </label>
            <input
              autoFocus
              type="text"
              className="form-control form-control-sm"
              placeholder="Buscar por nome, CNPJ ou cidade..."
              value={search}
              onChange={e => setSearch(e.target.value.toUpperCase())}
            />
          </div>

          {/* Tabela de resultados */}
          <div className="border rounded" style={{ overflowY: 'auto', flex: 1 }}>
            <table className="table table-hover table-sm mb-0">
              <thead className="table-light">
                <tr>
                  <th className="small">Nome</th>
                  <th className="small">CNPJ</th>
                  <th className="small d-none d-sm-table-cell">Cidade / UF</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(e => (
                  <tr
                    key={e.cnpj}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleSelect(e)}
                    className={selectedCnpj === e.cnpj ? 'table-success' : ''}
                  >
                    <td className="small">{e.nome}</td>
                    <td className="small">{e.cnpj}</td>
                    <td className="small d-none d-sm-table-cell">{e.municipio} / {e.uf}</td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr>
                    <td colSpan={3} className="text-center text-muted small py-3">
                      <i className="bi bi-inbox me-2"></i>Nenhuma escola encontrada.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer" style={{ padding: '0.4rem 1rem' }}>
          <span className="text-muted small me-auto">
            {filtered.length} registro{filtered.length !== 1 ? 's' : ''} encontrado{filtered.length !== 1 ? 's' : ''}
          </span>
          <button type="button" className="btn btn-secondary btn-sm" onClick={handleClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default EscolaPicker;
